import React from "react";

import { FormEnabler, ValidatedForm, MInput } from "components/forms";
import { Container } from "design-react-kit";
import { MTable } from "components/table";

import { Button, Card, CardBody } from "design-react-kit";
import { networkErrorHelper } from "libs";
import { ModalHandler } from "components/misc";

export class AdminLessonScheduleTrainingForm extends ValidatedForm {
  state = {
    start: "",
    end: "",
    rndKey: 0,
    trainings: this.props.trainings || [],
    formActive: false,
  };

  ERROR_MESSAGES = {
    start: "Ora inizio obbligatoria",
    end: "Ora fine obbligatoria ",
  };

  validation = {
    start: (value) => {
      return value !== null && value !== "";
    },
    end: (value) => {
      return value !== null && value !== "";
    },
  };

  tableConfig = {
    columns: [
      { id: "index", Header: "#", Cell: ({ row }) => row.index + 1 },
      {
        id: "id", // identifier of columns
        Header: "Column 0",
        isVisible: false, // IMPORTANT: hidden columns
        accessor: "id", // accessor is the "key" in the data
      },
      {
        id: "start",
        Header: "Ora inizio",
        accessor: (row) => (row.start ? row.start.substring(0, 5) : ""),
      },
      {
        id: "end",
        Header: "Ora fine",
        accessor: (row) => (row.end ? row.end.substring(0, 5) : ""),
      },
    ],
    actions: [],
  };

  componentDidUpdate(prevProps) {
    if (prevProps.trainings !== this.props.trainings) {
      this.setState({
        trainings: this.props.trainings || [],
        rndKey: Math.floor(Math.random() * 1000 + 1),
      });
    }
  }

  addRow = () => {
    const lessonId = parseInt(this.props.lessonId);

    this.setState((prev) => ({
      trainings: [
        ...prev.trainings,
        { start: "", end: "", note: "", lessonId },
      ],
    }));
  };

  removeRow = (index) => {
    this.setState((prev) => {
      const updated = [...prev.trainings];
      updated.splice(index, 1);
      return { trainings: updated };
    });
  };

  updateRow = (index, field, value) => {
    const updated = [...this.state.trainings];

    if ((field === "start" || field === "end") && value && value.length === 5) {
      value = value + ":00"; //  HH:mm -> HH:mm:ss
    }

    updated[index][field] = value;
    this.setState({ trainings: updated });
  };

  toggleForm = () => {
    this.setState({
      formActive: !this.state.formActive,
    });
  };

  onSubmit = () => {
    let isValid = this.checkValidation();

    if (isValid) {
      // validate and submit inner validatedForm component
      this.innerValidatedForms.forEach((component) => {
        if (!component.onSubmit()) {
          isValid = false;
        }
      });
    }

    // if all components are valid submit this
    if (isValid) {
      this.saveRemote();
    }
    return isValid;
  };

  //--- start functions to delete procedure ---
  deleteRecord(value) {
    ModalHandler.show(
      value,
      "Eliminazione definitiva del dato",
      "vuoi davvero eliminare?",
      null,
      this.deletePermanentlyConfirmed
    );
  }

  deletePermanentlyConfirmed = (value) => {
    this.props
      .deleteTraining(value)
      .then(() => {
        this.props.onSave();
      })
      .catch((error) => {
        console.log(error);
        if (!networkErrorHelper.is404(error)) {
          networkErrorHelper.notify(error);
        }
      });
  };
  //--- end functions to delete procedure ---

  saveRemote = () => {
    const { trainings } = this.state;
    const lessonId = parseInt(this.props.lessonId);

    const payload = { lessonId, trainings };

    this.props
      .saveTrainings(payload)
      .then(() => {
        this.setState({
          formActive: false,
          rndKey: Math.floor(Math.random() * 1000 + 1),
        });

        this.props.onSave();
      })
      .catch((errors) => {
        networkErrorHelper.notify(errors);
      });
  };

  renderInfo() {
    return (
      <Container className="my-5">
        <h3>Esercitazioni</h3>
        <MTable
          key={this.state.rndKey}
          tableData={this.state.trainings}
          tableConfig={this.tableConfig}
        />
        <Button color="primary bg-dark float-right" onClick={this.toggleForm}>
          Modifica
        </Button>
      </Container>
    );
  }

  renderForm() {
    const { trainings } = this.state;

    return (
      <>
        <h3>Gestione esercitazioni</h3>
        <form>
          <div className="d-flex justify-content-end mb-3">
            <Button
              color="primary bg-dark"
              className="mt-3"
              onClick={this.addRow}
            >
              Aggiungi esercitazione
            </Button>
          </div>
          {trainings.map((row, index) => (
            <div className="row my-5" key={index}>
              <div className="col-md-4">
                <MInput
                  id={`start-${index}`}
                  label="Ora inizio"
                  value={row.start ? row.start.substring(0, 5) : ""}
                  type="time"
                  onChange={(id, value) =>
                    this.updateRow(index, "start", value)
                  }
                />
              </div>

              <div className="col-md-4">
                <MInput
                  id={`end-${index}`}
                  label="Ora fine"
                  type="time"
                  value={row.end ? row.end.substring(0, 5) : ""}
                  onChange={(id, value) => this.updateRow(index, "end", value)}
                />
              </div>

              <div className="col-md-2">
                <Button
                  color="primary bg-dark"
                  onClick={() =>
                    row.id ? this.deleteRecord(row.id) : this.removeRow(index)
                  }
                >
                  Rimuovi
                </Button>
              </div>
            </div>
          ))}
          <hr className="my-4" />
          <FormEnabler
            isFormActive={this.state.formActive}
            onCancel={this.toggleForm}
            onSubmit={this.onSubmit}
            disableSave={false}
          />
        </form>
      </>
    );
  }

  render() {
    return (
      <Card
        tag="div"
        className="my-4 card-bg card-big rounded shadow border-bottom-card"
      >
        <CardBody tag="div">
          {this.state.formActive ? this.renderForm() : this.renderInfo()}
        </CardBody>
      </Card>
    );
  }
}
